import * as CreDtos from "../CRE.dtos";

export const
    HOMESETTINGS_REQUEST = "HOMESETTINGS_REQUEST",
    HOMESETTINGS_REQUEST_FAILURE = "HOMESETTINGS_REQUEST_FAILURE",
    HOMESETTINGS_REQUEST_SUCCESS = "HOMESETTINGS_REQUEST_SUCCESS",
    HOMESETTINGS_REQUEST_UPSERT_REQUEST = "HOMESETTINGS_REQUEST_UPSERT_REQUEST",
    HOMESETTINGS_REQUEST_UPSERT_REQUEST_FAILURE = "HOMESETTINGS_REQUEST_UPSERT_REQUEST_FAILURE",
    HOMESETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS = "HOMESETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS"

export function homeSettingsRequest() {
    return {
        type: HOMESETTINGS_REQUEST
    };
}

export function homeSettingsRequestSuccess(homeSettings: CreDtos.HomeSettings) {
    return {
        type: HOMESETTINGS_REQUEST_SUCCESS,
        homeSettings
    };
}

export function homeSettingsRequestFailure(error) {
    return {
        type: HOMESETTINGS_REQUEST_FAILURE,
        error
    };
}

export function homeSettingsUpsertRequest(homeSettings: CreDtos.HomeSettings) {
    return {
        type: HOMESETTINGS_REQUEST_UPSERT_REQUEST,
        homeSettings
    };
}

export function homeSettingsUpsertRequestSuccess(homeSettings: CreDtos.HomeSettings) {
    return {
        type: HOMESETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS,
        homeSettings
    };
}

export function homeSettingsUpsertRequestFailure(error) {
    return {
        type: HOMESETTINGS_REQUEST_UPSERT_REQUEST_FAILURE,
        error
    };
}




// WEBPACK FOOTER //
// ./src/actions/homeSettings.actions.ts